import { validatePresence } from 'ember-changeset-validations/validators';
import validateOnCheck from 'volta/validators/on-check';
import validateCron from 'volta/validators/validate-cron';

import { isPresent } from '@ember/utils';

export default {
  group: validatePresence(true),
  service: validatePresence(true),
  cron: validateCron(),
  description: validatePresence(true),
  arg: {
    payload: validateOnCheck({
      checkKeys: [],
      checkCondition: (payload: string) => {
        if (!isPresent(payload)) {
          return true;
        }
        try {
          const parsed = JSON.parse(payload);
          return !!parsed;
        } catch (e) {
          return false;
        }
      },

      i18nKey: 'payload'
    })
  }
};
